import { r as s, c as n, h as a, g as c } from "./main-bb89b2f2.js";
import "vue";
const h = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.flex{display:flex}:host ::slotted(patternlib-selection-card){flex:1 0 auto}@media (min-width:768px){:host ::slotted(patternlib-selection-card){flex:0 1 auto}}.static{position:static}.\\!flex-row{flex-direction:row!important}.flex-col{flex-direction:column}.\\!flex-col{flex-direction:column!important}.flex-wrap{flex-wrap:wrap}.justify-start{justify-content:flex-start}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}@media (min-width:768px){.tablet\\:flex-row{flex-direction:row}}", d = h, f = class {
  constructor(e) {
    s(this, e), this.optionSelect = n(this, "lhSelect", 7), this.updateChildren = () => {
      const t = this.querySelectionCardItems();
      t == null || t.forEach((r) => {
        r.type = this.type, r.name = this.name, r.horizontal = this.horizontal;
      });
    }, this.name = "selection-card", this.width = "100%", this.gap = "16px", this.horizontal = !0, this.type = "radio", this.controlled = !1, this.value = "";
  }
  valueWatcher(e) {
    this.handleValueChange(e);
  }
  handleSelectionCardChange(e) {
    const t = e.detail;
    if (this.type === "radio")
      this.controlled || (this.value = t), this.optionSelect.emit({ selected: { value: t, name: this.name } });
    else {
      const r = this.querySelectionCardItems(), l = this.controlled ? (i) => i.checked === !0 && i.value !== t || !i.checked && i.value === t : (i) => i.checked === !0, o = r.filter(l).map((i) => ({
        value: i.value,
        name: this.name
      }));
      this.controlled || (this.value = o.map((i) => i.value)), this.optionSelect.emit({ selected: o });
    }
  }
  /**
   * Handle a value change. This is called, when the value changes programatically (not by the user selecting the value).
   */
  handleValueChange(e) {
    const t = this.querySelectionCardItems();
    if (e == null || Array.isArray(e) && e.length == 0) {
      t.forEach((r) => {
        r.checked = !1;
      });
      return;
    }
    if (this.type === "radio") {
      this.deselectAllOther(t, e);
      const r = t.find((l) => l.value == e);
      r != null && (r.checked = !0);
    } else
      this.type === "checkbox" && t.forEach((r) => r.checked = e.includes(r.value));
  }
  querySelectionCardItems() {
    const e = this.hostElement.querySelectorAll("patternlib-selection-card");
    return Array.from(e);
  }
  deselectAllOther(e, t) {
    e.filter((l) => l.value != t).forEach((l) => {
      l.checked = !1;
    });
  }
  componentWillLoad() {
    this.handleValueChange(this.value);
  }
  componentDidLoad() {
    this.updateChildren();
  }
  render() {
    const e = {
      gap: this.gap
    }, t = {
      "flex flex-col tablet:flex-row flex-wrap justify-start": !0,
      "!flex-row": this.horizontal,
      "!flex-col": !this.horizontal
    };
    return a("patternlib-form-group", { key: "f4c4b138c6ecab8975aeb213db835bef4bb05060", tabindex: "0" }, a("div", { key: "0c2d2c6f29343b1aeef9e78ebb95d5cb40683ffa", slot: "element", class: t, style: e }, a("slot", { key: "1c0578c6982173e2bd4dcc174af310323be49f1d", onSlotchange: this.updateChildren })));
  }
  get hostElement() {
    return c(this);
  }
  static get watchers() {
    return {
      value: ["valueWatcher"]
    };
  }
};
f.style = d;
export {
  f as patternlib_selection_card_group
};
